import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "countInput", "costDisplay"]
  static values = { costPerContact: Number }

  open() {
    this.dialogTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.dialogTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close()
  }

  updateCost() {
    if (!this.hasCostDisplayTarget || !this.hasCountInputTarget) return
    const count = parseInt(this.countInputTarget.value) || 0
    const cost = (count * this.costPerContactValue).toFixed(2)
    this.costDisplayTarget.textContent = cost
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
  }
}
